module.exports = __webpack_public_path__ + "static/images/styles/images/handle.38e9927e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/handle.png
// module id = 3628
// module chunks = 11